export default __webpack_public_path__ + "static/media/panel.dc2237f5.svg";